var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.pages > 1
    ? _c(
        "nav",
        { staticClass: "pages pagination" },
        [
          _c(
            "a",
            {
              attrs: { disabled: _vm.value == 1 },
              on: {
                click: function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "left", 37, $event.key, [
                      "Left",
                      "ArrowLeft"
                    ])
                  ) {
                    return null
                  }
                  if ("button" in $event && $event.button !== 0) {
                    return null
                  }
                  _vm.to(1)
                }
              }
            },
            [_vm._v("<<")]
          ),
          _c(
            "a",
            {
              staticClass: "around",
              attrs: { disabled: _vm.value == 1 },
              on: {
                click: function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "left", 37, $event.key, [
                      "Left",
                      "ArrowLeft"
                    ])
                  ) {
                    return null
                  }
                  if ("button" in $event && $event.button !== 0) {
                    return null
                  }
                  _vm.to(Math.max(_vm.value - 1, 1))
                }
              }
            },
            [_vm._v("<")]
          ),
          _vm._v(" "),
          _vm._l(_vm.shownpages, function(pg) {
            return _c(
              "a",
              {
                class: { around: Math.abs(pg - _vm.value) <= 3 },
                attrs: { disabled: pg == _vm.value },
                on: {
                  click: function($event) {
                    if (
                      !("button" in $event) &&
                      _vm._k($event.keyCode, "left", 37, $event.key, [
                        "Left",
                        "ArrowLeft"
                      ])
                    ) {
                      return null
                    }
                    if ("button" in $event && $event.button !== 0) {
                      return null
                    }
                    _vm.to(pg)
                  }
                }
              },
              [_vm._v(_vm._s(pg))]
            )
          }),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "around",
              attrs: { disabled: _vm.value == _vm.pages },
              on: {
                click: function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "left", 37, $event.key, [
                      "Left",
                      "ArrowLeft"
                    ])
                  ) {
                    return null
                  }
                  if ("button" in $event && $event.button !== 0) {
                    return null
                  }
                  _vm.to(Math.min(_vm.pages, _vm.value + 1))
                }
              }
            },
            [_vm._v(">")]
          ),
          _c(
            "a",
            {
              attrs: { disabled: _vm.value == _vm.pages },
              on: {
                click: function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "left", 37, $event.key, [
                      "Left",
                      "ArrowLeft"
                    ])
                  ) {
                    return null
                  }
                  if ("button" in $event && $event.button !== 0) {
                    return null
                  }
                  _vm.to(_vm.pages)
                }
              }
            },
            [_vm._v(">>")]
          )
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0eaa29f9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0eaa29f9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/helpers/mixins/pagination/Pages.vue
// module id = null
// module chunks = 